import React, { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import { toast } from 'sonner';

export default function AdminPedidos() {
  const [orders, setOrders] = useState([]);
  const [franchises, setFranchises] = useState([]);
  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    api.getOrders().then(setOrders).catch(() => {});
    api.getFranchisesFresh().then(setFranchises).catch(() => {});
    api.getValueLists().then((lists) => setStatuses(lists.find((l) => l.id === 'estados-pedido')?.values || [])).catch(() => {});
  }, []);

  const setStatus = async (id, status) => {
    try {
      const updated = await api.updateOrderStatus(id, status);
      setOrders((prev) => prev.map((o) => o.id === id ? updated : o));
      toast.success(`Pedido ${id} → ${status}`);
    } catch { toast.error('Error al actualizar el estado'); }
  };

  return (
    <div data-testid="admin-pedidos">
      <h1 className="text-2xl font-black text-stone-800 mb-1">Pedidos</h1>
      <p className="text-sm text-stone-500 mb-6">Cambia el estado directamente desde la tabla.</p>

      <div className="bg-white rounded-lg border border-stone-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500 text-left">
            <tr>
              <th className="px-4 py-3 font-medium">Pedido</th>
              <th className="px-4 py-3 font-medium">Fecha</th>
              <th className="px-4 py-3 font-medium">Cliente</th>
              <th className="px-4 py-3 font-medium">Productos</th>
              <th className="px-4 py-3 font-medium">Franquicia</th>
              <th className="px-4 py-3 font-medium">Legal</th>
              <th className="px-4 py-3 font-medium">Estado</th>
              <th className="px-4 py-3 font-medium text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-stone-100 align-top" data-testid={`order-row-${o.id}`}>
                <td className="px-4 py-3 font-bold text-stone-800">{o.id}</td>
                <td className="px-4 py-3 text-stone-500 text-xs">{new Date(o.createdAt).toLocaleDateString('es-ES')}</td>
                <td className="px-4 py-3">
                  <p className="text-stone-800 font-medium">{o.customer.name}</p>
                  <p className="text-xs text-stone-400">{o.customer.email}</p>
                </td>
                <td className="px-4 py-3 text-stone-600 text-xs">
                  {o.items.map((i, idx) => <p key={idx}>{i.name} ×{i.qty}</p>)}
                </td>
                <td className="px-4 py-3 text-stone-600 text-xs">{franchises.find((f) => f.id === o.franchiseId)?.name || '—'}</td>
                <td className="px-4 py-3 text-stone-400 text-[10px]" title="Snapshot legal en el momento de la compra">
                  {o.legalSnapshot ? Object.values(o.legalSnapshot).join(' ') : '—'}
                </td>
                <td className="px-4 py-3">
                  <select
                    value={o.status}
                    onChange={(e) => setStatus(o.id, e.target.value)}
                    className="border border-stone-200 rounded px-2 py-1.5 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-amber-400"
                    data-testid={`order-status-${o.id}`}
                  >
                    {statuses.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-right font-bold text-stone-800">{o.total.toFixed(2).replace('.', ',')} €</td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <p className="text-center text-stone-400 py-10">No hay pedidos todavía.</p>}
      </div>
    </div>
  );
}
